"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContactTemplate = void 0;
const lit_html_1 = require("lit-html");
const decorators_js_1 = require("lit/decorators.js");
const ref_js_1 = require("lit-html/directives/ref.js");
const lit_1 = require("lit");
const typedi_1 = require("typedi");
const intl_tel_input_1 = __importDefault(require("intl-tel-input"));
const control_1 = require("@common/form/control");
const auth_1 = require("@auth/services/auth");
const translation_1 = require("@translation/services/translation");
const country_1 = require("@common/services/country");
const contact_1 = require("@auth/services/contact");
const user_1 = require("@auth/services/user");
const loader_1 = require("@common/loader/templates/loader");
const emitter_1 = require("@event/services/emitter");
const type_1 = require("@event/type");
const popup_1 = require("../services/popup");
/**
 * Всплывающее окно редактирования контактов
 */
let ContactPopup = class ContactPopup extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Загрузка
         */
        this.loading = true;
        /**
         * Сохранение
         */
        this.saving = false;
        /**
         * Режим "регистрации"
         */
        this.registration = false;
        /**
         * Форма
         */
        this.form = new control_1.Form({
            address1: new control_1.TextControl(''),
            city: new control_1.TextControl(''),
            country: new control_1.TextControl(''),
            phonenumber: new control_1.TextControl(''),
            phonecountry: new control_1.TextControl(''),
            firstname: new control_1.TextControl(''),
            lastname: new control_1.TextControl(''),
            postcode: new control_1.TextControl(''),
            state: new control_1.TextControl(''),
            email: new control_1.TextControl(''),
        });
        /**
         * Тип аккаунта
         */
        this.typeAccount = new control_1.TextControl('');
        /**
         * Страны
         */
        this.countries = {};
        /**
         * Страна пользователя
         */
        this.preferredCountry = '';
        this.authService = typedi_1.Container.get(auth_1.AuthService);
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.countryService = typedi_1.Container.get(country_1.CountryService);
        this.contactService = typedi_1.Container.get(contact_1.ContactService);
        this.userService = typedi_1.Container.get(user_1.UserService);
        this.popupService = typedi_1.Container.get(popup_1.PopupService);
        this.eventEmitter = typedi_1.Container.get(emitter_1.EventEmitter);
        this.save = this.save.bind(this);
        this.initTelInput = this.initTelInput.bind(this);
        this.form.get('companyname') ? this.typeAccount.setValue('business') : this.typeAccount.setValue('individual');
    }
    /**
     * Обрабатывает событие инициализации
     */
    connectedCallback() {
        super.connectedCallback();
        const { registration } = this.params;
        this.registration = registration;
        this.init();
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Инициализирует компонент ввода номера телефона
     */
    initTelInput(el) {
        return __awaiter(this, void 0, void 0, function* () {
            yield new Promise(resolve => setTimeout(resolve));
            if (this.telInput) {
                return;
            }
            const input = el.querySelector('input');
            if (!input) {
                return;
            }
            this.telInput = (0, intl_tel_input_1.default)(input, {
                initialCountry: this.preferredCountry,
                separateDialCode: true,
            });
        });
    }
    /**
     * Генерирует представление
     */
    render() {
        const companyNameInput = this.typeAccount.getValue() == 'business'
            ? (0, lit_html_1.html) `<div class="col-12 col-sm-6">
                        <art-text-field class="d-block mb-5" name="companyname" placeholder="${this.translationService.instant('company_name_placeholder')}" labelText="${this.translationService.instant('clientareacompanyname')}" .control="${this.form.get('companyname')}" @enter="${this.save}"></art-text-field>
                    </div>`
            : null;
        return (0, lit_html_1.html) `
            <div class="modal fade" tabindex="-1" aria-labelledby="contactModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-md modal-dialog-centered modal-fullscreen-sm-down">
                    <div class="modal-content">
                        <header class="art-modal__header">
                            <button class="button-close button-close--black" type="button" data-bs-dismiss="modal" aria-label="close">
                                <span class="close__icon" aria-hidden="true"></span>
                            </button>
                        </header>
    
                        ${this.loading ? (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                <div class="mb-5">
                                    ${(0, loader_1.getLoaderTemplate)(true, this.translationService)}
                                </div>
                            </div>
                        ` : (0, lit_html_1.html) `
                            <div class="art-modal__body">
                                <h2 class="modal-title">${this.registration ? this.translationService.instant('domainregistrantinfo') : this.translationService.instant('clientareanavaddcontact')}</h2>
    
                                ${!this.registration
            ? (0, lit_html_1.html) `<p class="mb-5">${this.translationService.instant('you_may_specify_alternative_registered')}</p>`
            : null}
                                
                                <div class="row">
                                        <art-radio-field
                                        class="d-flex justify-content-start radio-group"
                                        .control="${this.typeAccount}"
                                        .values="${{
            individual: this.translationService.instant('individual'),
            business: this.translationService.instant('business'),
        }}"
                                        @change="${(e) => {
            this.loading = true;
            this.typeAccount.setValue(e.target.value);
            this.loading = false;
        }}"
                                    ></art-radio-field>
                                </div>
                                
                                <div class="row">
                                    <div class="col-12 col-lg-6">
                                        <art-text-field class="d-block mb-5" name="firstname" placeholder="${this.translationService.instant('john')}" labelText="${this.translationService.instant('clientareafirstname')}" .required=${true} .control="${this.form.get('firstname')}" @enter="${this.save}"></art-text-field>
                                    </div>

                                    <div class="col-12 col-lg-6">
                                        <art-text-field class="d-block mb-5" name="lastname" placeholder="${this.translationService.instant('doe')}" labelText="${this.translationService.instant('clientarealastname')}" .required=${true} .control="${this.form.get('lastname')}" @enter="${this.save}"></art-text-field>
                                    </div>
                                    
                                    ${companyNameInput}

                                    <div class="col-12 col-lg-6">
                                        <art-select-field class="d-block mb-5" name="country" label="${this.translationService.instant('clientareacountry')} *" .control="${this.form.get('country')}" .values="${this.countries}" @enter="${this.save}" @change="${this.countryChange}"></art-select-field>
                                    </div>

                                    <div class="col-12 col-lg-6">
                                        <art-text-field class="d-block mb-5" name="state" placeholder="" .required=${true} labelText="${this.translationService.instant('clientareastate')}" .control="${this.form.get('state')}" @enter="${this.save}"></art-text-field>
                                    </div>
                                     
                                    <div class="col-12 col-lg-6">
                                        <art-text-field class="d-block mb-5" name="city" placeholder="${this.translationService.instant('london')}" labelText="${this.translationService.instant('clientareacity')}" .required=${true} .control="${this.form.get('city')}" @enter="${this.save}"></art-text-field>
                                    </div>
                                    
                                    <div class="col-12 col-lg-6">
                                        <art-text-field ${(0, ref_js_1.ref)(this.initTelInput)} class="d-block mb-5" name="phonenumber" placeholder="${this.translationService.instant('clientareaphonenumber')}" labelText="${this.translationService.instant('phone')} *" .control="${this.form.get('phonenumber')}" @enter="${this.save}"></art-text-field>
                                    </div>

                                    <div class="col-12 col-lg-6">
                                        <art-text-field class="d-block mb-5" name="address1" placeholder="${this.translationService.instant('main_address')}" labelText="${this.translationService.instant('clientareaaddress1')}" .required=${true} .control="${this.form.get('address1')}" @enter="${this.save}"></art-text-field>
                                    </div>

                                    <div class="col-12 col-lg-6">
                                        <art-text-field class="d-block mb-5" name="postcode" placeholder="${this.translationService.instant('or_zip')}" labelText="${this.translationService.instant('clientareapostcode')}" .required=${true} .control="${this.form.get('postcode')}" @enter="${this.save}"></art-text-field>
                                    </div>
                                    
                                    <div class="col-12 col-sm-6">
                                        <art-text-field class="d-block mb-5" name="vat" placeholder="${this.translationService.instant('example_vat')}" labelText="${this.translationService.instant('aa_field_vat_number')}" .control="${this.form.get('vat')}" @enter="${this.save}"></art-text-field>
                                    </div>
                                </div>
                                
                                <div class="row mt-1">
                                    <div class="col-12 col-md-6">
                                        <button class="btn btn-secondary w-100 mb-1" data-bs-dismiss="modal" ?disabled="${this.saving}">${this.translationService.instant('cancel')}</button>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <button class="btn btn-primary w-100 mb-1" @click="${this.save}" ?disabled="${this.saving}">${this.registration ? this.translationService.instant('aa_regcomplete') : this.translationService.instant('supportticketsticketsubmit')}</button>
                                    </div>
                                </div>
                                
                                <div class="row mt-5">
                                    <div class="col">
                                        <div class="d-flex">
                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="5" cy="5.00012" r="4.5" stroke="black"/>
                                                <path d="M5.49203 5.48013H4.52003L4.35803 2.96613H5.64203L5.49203 5.48013ZM5.00603 7.03413C4.65803 7.03413 4.37003 6.74013 4.37003 6.39813C4.37003 6.05013 4.65803 5.75613 5.00603 5.75613C5.35403 5.75613 5.64203 6.05013 5.64203 6.39813C5.64203 6.74013 5.35403 7.03413 5.00603 7.03413Z" fill="black"/>
                                            </svg>
                                            <div class="text-xs">
                                                <ul>
                                                    <li>
                                                        ${this.translationService.instant('clientareanotice')}                                                    
                                                    </li>
                                                    <li>
                                                        ${this.translationService.instant('required_star_text2')}                                            
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `}
                    </div>
                </div>
            </div>
        `;
    }
    /**
     * Инициализирует состояние
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            try {
                const { data: userData } = yield this.userService.info();
                const { data: { items } } = yield this.countryService.getCountries();
                this.countries = items;
                this.preferredCountry = userData.country || Object.keys(items)[0] || '';
                this.form.patchValue({
                    country: this.preferredCountry,
                    email: userData.email || '',
                });
            }
            catch (err) {
            }
            finally {
                this.loading = false;
            }
        });
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            this.saving = true;
            try {
                yield this.contactService.addContact(this.getFormattedForm(this.form.getValue()));
                this.eventEmitter.emit(type_1.EventType.CONTACTS_UPDATED);
                this.popupService.close();
            }
            catch (err) {
                if (err.errors) {
                    this.form.setErrors(err.errors);
                }
            }
            finally {
                this.saving = false;
            }
        });
    }
    /**
     * Форматирует номер телефона с заданной страной
     */
    getFormattedForm(form) {
        const { iso2 = '' } = this.telInput.getSelectedCountryData();
        if (iso2) {
            form['phonenumber'] = `${form['phonenumber']}`;
            form['phonecountry'] = iso2.toUpperCase();
        }
        return form;
    }
    /**
     * Смена флаа в поле телефон после смены страны
     */
    countryChange(e) {
        const country = e.target.value.toLowerCase();
        this.telInput.setCountry(country);
    }
};
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], ContactPopup.prototype, "loading", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], ContactPopup.prototype, "saving", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", Object)
], ContactPopup.prototype, "params", void 0);
ContactPopup = __decorate([
    (0, decorators_js_1.customElement)('art-contact-popup'),
    __metadata("design:paramtypes", [])
], ContactPopup);
/**
 * Возвращает шаблон авторизации пользователя
 */
function getContactTemplate(params) {
    return (0, lit_html_1.html) `<art-contact-popup .params="${params}"></art-contact-popup>`;
}
exports.getContactTemplate = getContactTemplate;
window.PopupController.registerTemplate('contact', getContactTemplate);
